import { get, findIndex, isEmpty } from 'lodash'
import { GET_MASTER_DATA, GET_SHIPS_DATA, GET_VIP_ICONS_DATA } from './../constants/actionTypes'
import {
  isSameOrAfter,
  isDateBetween,
  convertDateTo_YYYY_MM_DD_T_HH_mm_ss
} from '../helpers/dateUtil'
import { getGroupByDesignation } from '../helpers/util'

const pastCurrentFutureVoyages = (voyages, voyagesCount, activeVoyage = 0) => {
  let currentFutureVoyages = []
  let pastVoyages = []
  {
    for (let i = 0; i < activeVoyage; i++) {
      pastVoyages.push(voyages[i])
    }

    currentFutureVoyages.push(voyages[activeVoyage])
    for (let i = 1; i <= voyagesCount.future; i++) {
      if (activeVoyage + i < voyages.length) {
        currentFutureVoyages.push(voyages[activeVoyage + i])
      }
    }
  }

  return {
    currentFutureVoyages,
    pastVoyages
  }
}

const masterdata = (store = {}, action = {}) => {
  switch (action.type) {
    case GET_MASTER_DATA: {
      let currentFutureVoyages = []
      let pastVoyages = []
      const voyages = get(action.data, 'voyages', [])
      const isShip = get(action.settings, 'ship.code', '')
      const isShore = get(action, 'isShore', false)
      if (!isEmpty(isShip) && !isShore) {
        const activeVoyage = findIndex(voyages, { isActive: true })
        const voyagesCount = get(action.settings, 'voyagesCount', {})
        if (activeVoyage >= 0 && !isEmpty(voyagesCount)) {
          const pastCurrentFuture = pastCurrentFutureVoyages(
            voyages,
            voyagesCount,
            activeVoyage
          )
          currentFutureVoyages = pastCurrentFuture.currentFutureVoyages
          pastVoyages = pastCurrentFuture.pastVoyages
        }
      } else {
        const today = convertDateTo_YYYY_MM_DD_T_HH_mm_ss(new Date())
        let firstVoyageIndex = false
        voyages.forEach((voyage, index) => {
          if (
            isDateBetween(today, voyage.embarkDate, voyage.debarkDate) ||
            isSameOrAfter(voyage.embarkDate, today)
          ) {
            if (isEmpty(currentFutureVoyages)) firstVoyageIndex = index
            currentFutureVoyages.push(voyage)
          }
        })

        if (firstVoyageIndex) {
          if (firstVoyageIndex) {
            for (let i = firstVoyageIndex; i > 0; i--) {
              pastVoyages.push(voyages[firstVoyageIndex - i])
            }
          }
        }
      }
      if (get(action.settings, 'isOnlyShowDesignation', false)) {
        let designationReviewerList = []
        let designationSubmittedByList = []
        designationReviewerList = !isEmpty(get(action.data, 'reviewerList', []))
          ? getGroupByDesignation(get(action.data, 'reviewerList', []))
          : []
        designationSubmittedByList = !isEmpty(
          get(action.data, 'submittedByList', [])
        )
          ? getGroupByDesignation(get(action.data, 'submittedByList', []))
          : []
        action.data = {
          ...action.data,
          designationReviewerList,
          designationSubmittedByList
        }
      }
      pastVoyages = pastVoyages.map(pastVoyage => {
        return { ...pastVoyage, isPastVoyage: true }
      })
      currentFutureVoyages = currentFutureVoyages.map(voyage => {
        return { ...voyage, isPastVoyage: false }
      })
      return {
        ...action.data,
        pastVoyages,
        currentFutureVoyages
      }
    }
    default:
      return store
  }
}

const ships = (store = [], action = []) => {
  switch (action.type) {
    case GET_SHIPS_DATA:
      return action.data
    default:
      return store
  }
}

const vipIcons = (store = [], action = []) => {
  switch (action.type) {
    case GET_VIP_ICONS_DATA:
      return action.data
    default:
      return store
  }
}

export { masterdata, ships, vipIcons }
